export default __webpack_public_path__ + "static/media/braces-3597591_1920.a5070afc.jpg";